"use client";
import { SVGProps } from "react";
import styled, { css, keyframes } from "styled-components";
import { UnderlineIcon } from "../icons/UnderlineIcon";
import { StyledTitle } from "../styles/globalsStyles";

function TitleWithBorder(
  svgProps: SVGProps<SVGSVGElement> & { text: string; isInView?: boolean }
) {
  const { text, isInView } = svgProps;
  const propsForSvg = JSON.parse(JSON.stringify(svgProps));
  delete propsForSvg.text;
  delete propsForSvg.isInView;
  return (
    <TitleAndBorderWrap>
      <StyledTitle dangerouslySetInnerHTML={{ __html: text }}></StyledTitle>
      <StyledUnderlineIcon {...propsForSvg} $isInView={isInView} />
    </TitleAndBorderWrap>
  );
}

const BorderAnimationAnimation = keyframes`
  0%{
  transform: scale(0);
  } 
  100%{
  transform: scale(1);

  } 
`;

const StyledUnderlineIcon = styled(UnderlineIcon)<
  { $isInView?: boolean } & SVGProps<SVGSVGElement>
>`
  ${(p) =>
    p.$isInView &&
    css`
      animation: ${BorderAnimationAnimation} 1s forwards;
    `}
`;

const TitleAndBorderWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default TitleWithBorder;
